import { apiStore } from '../../modules/apiHelper';

export default {
  addMentor(state, data) {
    if (!state.mentors.find(m => m.id === data.id)) {
      state.mentors.unshift(data);
      apiStore.setItem('mymentors', state.mentors);
    }
  },
  updateMentor(state, { id, prop, value }) {
    const index = state.mentors.findIndex(m => m.id === id);

    if (index >= 0) {
      // console.log('updating mentor ', prop, state.mentors.find(m => m.id === id));
      state.mentors[index][prop] = value;
      apiStore.setItem('mymentors', state.mentors);
    }
  },
  addMenteeGoal(state, goalid) {
    if (!state.goals.find(g => g === goalid)) {
      // console.log('adding mentee goal');
      state.goals.push(goalid);
    }
  },
  removeMenteeGoal(state, goalid) {
    const index = state.goals.indexOf(goalid);

    if (index >= 0) {
      state.goals.splice(index, 1);
    }
  },
  addTask(state, task) {
    if (!state.tasks.find(m => m.id === task.id)) {
      state.tasks.unshift(task);
    } else {
      const index = state.tasks.findIndex(t => t.id === task.id);

      if (index >= 0) {
        Object.assign({}, state.tasks[index], task);
      }
    }
  },
  updateTask(state, { id, prop, value }) {
    const index = state.tasks.findIndex(t => t.id === id);

    if (index >= 0) {
      // console.log('updating mentor ', prop, state.mentors.find(m => m.id === id));
      state.tasks[index][prop] = value;
    }
  },
  clearMenteeData(state) {
    state.mentors = [];
    state.goals = [];
    state.tasks = [];
    apiStore.removeItem('menteegoals');
  },
  setGoalGroup(state, goalGroup) {
    state.goalGroup = goalGroup;
  },
};
